export default {
  buyer_create_question: {
    management: {
      create_new: '新しいアンケートを作成',
      create_new_start: '最初から作成',
      create_new_start_description: '設問を1つずつ自由に追加して、独自のアンケートを作成できます。',
      create_by_template: 'テンプレートから作成',
      create_by_template_description: 'よく使われる構成をもとに、効率よくアンケートを作成できます。',
      created_survey_list_title: '作成済みのアンケート',
      survey: 'アンケート',
      number_of_survey: 'アンケート発行数',
      supplier: '@:esg_data.company_name',
    },
    list: {
      number_of_answered_company: '@:evaluation_dashboard.answer_transition.companies_submitted',
      no_survey: '作成済みのアンケートはありません',
      number_of_suppliers: '会社数',
    },
    flow: {
      title: 'アンケート作成の流れ',
      basic: '基本設定',
      basic_description: 'アンケートのタイトルや回答期限、使用言語などを設定します。',
      create_description: '設問を追加し、回答形式や翻訳、分岐などを設定します。',
      confirm_description: '入力内容と翻訳を確認し、調査開始前の最終確認を行います。',
      issue_url: 'URL発行',
      issue_url_description: '回答用URLを発行し、対象社に案内します。',
    },
    language: '言語',
    language_description: 'アンケートの言語を11言語から複数選べます。回答者には、システムの言語設定に応じた言語でアンケートが表示されます。',
    base_language: '基準言語',
    add_language: '翻訳を追加する言語',
    caution: '※調査開始後は変更できません。',
    survey_title: 'タイトル',
    survey_title_description: 'アンケートの名前を入力してください。回答者に表示されます。',
    answer_deadline_description: '回答の締切日を設定します。回答者に表示されます。',
    number_of_target_company: '対象社数',
    number_of_target_company_description_1: '今回回答を依頼する予定の会社数を入力してください。',
    number_of_target_company_description_2: 'ダッシュボードに対象社数に応じた登録率や回答率が表示され、進捗が把握しやすくなります。',
    btn: {
      save_and_exit: '保存して終了',
      preview: 'プレビュー',
      back_edit: '編集に戻る',
      start_survey: '調査を開始',
      copy_url: 'URLをコピー',
    },
    create: {
      back_settings: '基本設定を編集',
      bundle: '見出し',
      question: '@:list_table_filter.csv_modal_answer_heading_question',
      structure: '構成',
      error_alert: '修正箇所があります',
      question_text: '設問文',
      required_type: '回答の必須/任意',
      guide: 'ガイド',
      answer_type: '回答形式',
      single_select: '単一選択',
      multiple_selects: '複数選択',
      text: '記述',
      number: '数値',
      amount: '金額',
      selects: '選択肢',
      selects_add: '追加入力',
      selects_branch: '分岐',
      selects_branching_question: '選択時の分岐質問',
      selects_add_description: '選択時に追加入力',
      remarks: '備考欄',
      attach: 'ファイル添付',
      copy_question: '設問をコピー',
      delete_question: '設問を削除',
      label: 'ラベル',
      answer_field: '回答欄',
      caution_conditional_required: '分岐設定されているため変更できません。',
      error_category_without_bundle: 'カテゴリには必ず見出しを1つ以上設定してください。',
      error_bundle_without_question: '見出しには必ず設問を1つ以上設定してください。',
    },
    start_survey_modal: {
      title: '調査を開始する',
      description_1: '編集を完了して調査を開始しますか？',
      description_2: '調査開始後は、アンケートの変更ができません。',
    },
    registration_url: '回答用URL',
    registration_url_description_1: '回答用URLを発行しました。',
    registration_url_description_2: 'アンケートへの回答を依頼する際に、このURLを対象企業に案内してください。',
    registration_default_language: 'デフォルトの表示言語',
    url_copied: 'URLをコピーしました',
    status: {
      draft: '作成中',
      investigating: '調査中',
    }
  },
};
